<template>
    <v-container>
        <ModuleClosedAlert module="site.review.create.lawyer" />
        <v-row>
            <v-col>
                <div class="font-weight-bold mt-10 title-page" tabindex="0">Revisão de Crédito</div>
            </v-col>
        </v-row>

        <br />

        <div class="mt-4" v-if="dataset.loading">
            <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
        </div>

        <div v-if="!dataset.loading && !user" v-html="dataset.contentUserAnonymous"></div>
        <div v-if="!dataset.loading && user && dataset.notAcceptedValue" v-html="dataset.contentUserLogged"
            tabindex="0"></div>

        <br>
        <v-row v-if="user">
            <v-col cols="12" sm="6">
                <v-select v-model="selectedCreditorId" :items="linkedCreditors" item-value="id"
                    label="Selecione o Credor" outlined dense @change="onCreditorChange" :rules="[$rules.required]">
                    <template v-slot:item="data">
                        <template v-if="data.item">
                            <div class="mb-2">
                                <span>{{ data.item.name }}</span><br>
                                <small class="grey--text"><strong>{{ data.item.registration }}</strong></small>
                            </div>
                        </template>
                    </template>

                    <template v-slot:selection="data">
                        <span>{{ data.item.name }}</span>
                    </template>

                    <template v-slot:no-data>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="text--disabled">
                                    Nenhum dado disponível
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>

                </v-select>
            </v-col>
        </v-row>

        <v-form v-if="user && showMainForm && !dataset.loading" class="pt-4" ref="form" v-model="dataForm.validForm">


            <div v-if="dataset.isAssociationCreditor">
                <v-row class="justify-start">
                    <v-col cols="12" class="mb-0">
                        <strong tabindex="0">Você concorda com o valor de {{ dataset.userRequestedValue | currency }}
                            ?</strong>
                    </v-col>
                    <v-col cols="12" class="mt-n5">
                        <v-radio-group v-model="dataset.acceptValue">
                            <v-radio aria-label="Selecionado sim" label="Sim" :value="true"></v-radio>
                            <v-radio aria-label="Selecionado não" label="Não" :value="false"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
            </div>

            <!-- <template v-if="!dataset.acceptValue || !dataset.isAssociationCreditor"> -->
            <template v-if="dataset.notAcceptedValue || !dataset.isAssociationCreditor">
                <!-- <v-row>
                    <v-col cols="12">
                        <span class="mr-3"> <strong>Você gostaria de habilitar ou divergir de um crédito relacionado a
                                qual empresa?</strong></span>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon small :color="'primary'" v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                            </template>
    <span>Selecione a empresa a qual gostaria de habilitar ou divergir de um crédito</span>
    </v-tooltip>
    </v-col>
    </v-row>

    <v-row>
        <v-col cols="12" sm="12">
            <v-autocomplete :disabled="dataset.loading" dense required :items="dataset.clients"
                label="Selecione a devedora" v-model="dataset.data.client" item-value="id" item-text="name"
                :rules="[$rules.required]" outlined hide-details="auto">
            </v-autocomplete>
        </v-col>
    </v-row> -->

                <template>

                    <v-row class="justify-start">
                        <v-col cols="12">
                            <span tabindex="0" class="mr-3"> <strong>Possui ação judicial em andamento ou com trânsito
                                    em julgado certificado?</strong></span>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon small :color="'primary'" v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                                </template>
                                <span>Caso possua uma ação judicial em andamento, marque "SIM" e preencha os dados
                                    abaixo</span>
                            </v-tooltip>
                        </v-col>

                        <v-col cols="12" class="mt-n7">
                            <v-radio-group v-model="dataset.data.actionProgress">
                                <v-radio aria-label="Selecionado sim" label="Sim" :value="true"></v-radio>
                                <v-radio aria-label="Selecionado não" label="Não" :value="false"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>

                    <!-- <template v-if="dataset.data.actionProgress === true">

                        <v-row class="mt-n5">
                            <v-col cols="5" sm="5">
                                <v-text-field :disabled="dataset.loading" dense required label="Número do processo"
                                    :rules="[$rules.required]" v-model="dataset.data.process_number" outlined
                                    hide-details="auto">
                                </v-text-field>
                            </v-col>

                            <v-col cols="3" sm="3">
                                <v-autocomplete :disabled="dataset.loading" dense required :items="dataset.statesList"
                                    label="Local de tramitação" v-model="dataset.data.process_local" item-value="name"
                                    item-text="name" :rules="[$rules.required]" outlined hide-details="auto">
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="4" sm="4">
                                <v-autocomplete :disabled="dataset.loading" dense :items="dataset.courtList"
                                    label="Tribunal de tramitação" v-model="dataset.data.process_court"
                                    item-value="name" item-text="name" outlined hide-details="auto">
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <br>
                    </template> -->


                    <template v-if="dataset.data.actionProgress === true">
                        <!-- <div v-for="(process, index) in processes" :key="index"> -->
                        <div v-for="(process, index) in processes" :key="process.id || `process-${index}`">
                            <v-row class="mt-n5">
                                <v-col cols="5" sm="5">
                                    <v-text-field aria-label="Digite o numero do processo" :disabled="dataset.loading"
                                        dense required label="Número do processo" :rules="[$rules.required]"
                                        v-model="process.number" outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="3" sm="3">
                                    <v-autocomplete aria-label="Selecione o estado de tramitação do processo"
                                        :disabled="dataset.loading" dense required :items="dataset.statesList"
                                        label="Local de tramitação" v-model="process.local" item-value="name"
                                        item-text="name" :rules="[$rules.required]" outlined hide-details="auto">
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="4" sm="4">
                                    <v-autocomplete aria-label="Selecione o tribunal de tramitação do processo"
                                        :disabled="dataset.loading" dense :items="dataset.courtList"
                                        label="Tribunal de tramitação" v-model="process.court" item-value="name"
                                        item-text="name" outlined hide-details="auto">
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="12" class="d-flex justify-end mt-n2">

                                    <!-- Remove Button -->
                                    <v-tooltip v-if="processes.length > 1" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" @click="removeProcess(index)"
                                                color="#E57373" dark x-small
                                                aria-label="Botão para remover linha de processo">
                                                <v-icon>mdi-minus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Remover linha de dados</span>
                                    </v-tooltip>

                                    <!-- ADD Button -->
                                    <v-tooltip v-if="processes.length < 10 && index === processes.length - 1" bottom>
                                        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                                            <v-btn class='ml-2' v-bind="tooltipAttrs" v-on="tooltipOn"
                                                @click="addProcess" color="green" dark x-small
                                                aria-label="Botão para adicionar linha de processo">
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Adicionar linha de dados</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                            <br>
                        </div>
                    </template>

                    <v-row>
                        <v-col v-if="!dataset.loading">
                            <div class="d-flex align-center">
                                <h3 class="mr-5"><strong>Negócios</strong></h3>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                                        <v-btn v-bind="tooltipAttrs" v-on="tooltipOn" @click="addItem" color="green"
                                            dark x-small aria-label="Botão para adicionar um novo negócio">
                                            Adicionar <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Adicionar um novo negócio</span>
                                </v-tooltip>
                            </div>
                        </v-col>
                    </v-row>

                    <!-- <v-row>
                        <v-col v-if="!dataset.loading" >
                            <h3><strong>Negócios</strong></h3>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                                <v-btn class='ml-8' v-bind="tooltipAttrs" v-on="tooltipOn" @click="addItem" color="green" dark x-small>
                                    Adicionar <v-icon>mdi-plus</v-icon>
                                </v-btn>
                                </template>
                                <span>Adicionar um novo negócio</span>
                            </v-tooltip> 
                        </v-col>
                    </v-row> -->
                    <br>

                    <!-- <v-row>
                        <v-col>
                            <p v-if="!dataset.loading">
                                Para adicionar um novo negócio,
                                <a href="#" @click.prevent="addItem"><strong>clique aqui</strong></a>
                            </p>
                        </v-col>
                    </v-row> -->
                </template>

                <div v-for="(item, i) in dataset.data.items" :key="i">
                    <v-row>
                        <v-col>
                            <strong>Negócio #{{ getItemNumber(i) }}</strong>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class='ml-5' v-bind="attrs" v-on="on" @click="removeItem(i)" dark
                                        color="#E57373" x-small aria-label="Botão para remover um negocio      ">
                                        Remover <v-icon>mdi-minus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Excluir negócio atual</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-expansion-panels>
                                <v-expansion-panel>
                                    <v-expansion-panel-header
                                        aria-label="Formulario para ser preenchido com os dados do negócio">
                                        <div>
                                            <strong>Origem: </strong>
                                            <span>{{
                                                truncateText(item.origin || 'N/A', 30)
                                                }}</span>
                                            /
                                            <strong>Valor: </strong>
                                            <span v-if="item.amount">
                                                <!-- {{ item.amount | currency }}</span><span v-else>N/A</span> -->
                                                {{ formatValue(item.amount, item.currency) }}</span><span
                                                v-else>N/A</span>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-row>
                                            <v-col cols="12">
                                                <span class="mr-3"> <strong>Selecione a origem do
                                                        crédito</strong></span>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon small :color="'primary'" v-bind="attrs"
                                                            v-on="on">mdi-help-circle</v-icon>
                                                    </template>
                                                    <span>Selecione o motivo que gerou os valores do crédito</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="12">
                                                <v-autocomplete :disabled="dataset.loading" dense required
                                                    :items="dataset.creditorOriginTypes"
                                                    label="Selecione a origem do crédito" v-model="item.origin"
                                                    item-value="name" item-text="name" :rules="[$rules.required]"
                                                    outlined hide-details="auto" @change="onOriginChange(item, i)">
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <span class="mr-3"> <strong>Informe a moeda e o valor referente ao
                                                        negócio</strong></span>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon small :color="'primary'" v-bind="attrs"
                                                            v-on="on">mdi-help-circle</v-icon>
                                                    </template>
                                                    <span>Informe o tipo de moeda e o valor devido</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6">
                                                <v-select :disabled="dataset.loading" dense id="type"
                                                    :items="dataset.currencyTypes" label="Selecione uma moeda"
                                                    v-model="item.currency" item-value="id" item-text="name" outlined
                                                    hide-details="auto">
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-currency-field :disabled="dataset.loading" label="Valor" dense
                                                    aria-label="Digite o valor do negocio" v-model="item.amount"
                                                    :allowNegative="false" hide-details="auto" outlined required
                                                    :rules="[$rules.required]">
                                                </v-currency-field>
                                            </v-col>
                                        </v-row>


                                        <v-row>
                                            <v-col cols="12">
                                                <span class="mr-3"> <strong>Selecione a empresa devedora</strong></span>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon small :color="'primary'" v-bind="attrs"
                                                            v-on="on">mdi-help-circle</v-icon>
                                                    </template>
                                                    <span>Selecione a empresa devedora do crédito</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <v-col cols="12" sm="12">
                                                <v-autocomplete :disabled="dataset.loading" dense required
                                                    :items="dataset.clients" label="Selecione a devedora"
                                                    v-model="item.company_name" item-value="name" item-text="name"
                                                    :rules="[$rules.required]" outlined hide-details="auto">
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <v-col cols="12">
                                                <span class="mr-3"> <strong>Informe o número de identificação do
                                                        pedido/cotação/contrato/outro</strong></span>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon small :color="'primary'" v-bind="attrs"
                                                            v-on="on">mdi-help-circle</v-icon>
                                                    </template>
                                                    <span>Informe o número de identificação do pedido</span>
                                                </v-tooltip>

                                            </v-col>

                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" class="mt-n3">
                                                <v-text-field :disabled="dataset.loading" dense
                                                    label="Identificação do pedido" v-model="item.request_number"
                                                    aria-label="Digite o numero de identificação do pedido" outlined
                                                    hide-details="auto">
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <v-col cols="12" sm="6">
                                                <span class="mr-3"> <strong>Informe a sua classe no
                                                        processo</strong></span>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon small :color="'primary'" v-bind="attrs"
                                                            v-on="on">mdi-help-circle</v-icon>
                                                    </template>
                                                    <span>Selecione a sua classe no processo</span>
                                                </v-tooltip>
                                            </v-col>

                                            <v-col cols="12" sm="6">
                                                <span class="mr-3">
                                                    <strong>
                                                        {{
                                                        item.textDateLabel === 2 ?
                                                        'Data de rescisão do contrato de trabalho' :
                                                        item.textDateLabel === 1 ?
                                                        'Data da compra / assinatura do contrato' :
                                                        'Data do evento'
                                                        }}
                                                    </strong>
                                                </span>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon small :color="'primary'" v-bind="attrs"
                                                            v-on="on">mdi-help-circle</v-icon>
                                                    </template>
                                                    <span>
                                                        {{
                                                        item.textDateLabel === 2 ?
                                                        'Informe a data de rescisão do contrato de trabalho' :
                                                        item.textDateLabel === 1 ?
                                                        'Informe a data da compra / assinatura do contrato' :
                                                        'Data do evento'
                                                        }}
                                                    </span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <v-col cols="12" sm="6">
                                                <v-select dense :items="dataset.creditorTypes" label="Classe"
                                                    v-model="item.type" item-value="id" item-text="name" outlined
                                                    hide-details="auto" :rules="[$rules.required]"
                                                    @change="onClassChange(item, i)">
                                                </v-select>
                                            </v-col>

                                            <v-col cols="12" sm="6">
                                                <v-text-field dense type="date" label="Data"
                                                    :value="item.ref_date ? $moment(item.ref_date).utc().format('YYYY-MM-DD') : null"
                                                    outlined hide-details="auto" @input="updateRefDate($event, i)">
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <v-col cols="12">
                                                <span class="mr-3"> <strong>Adicione documento(s) comprobatório(s) do
                                                        negócio</strong></span>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon small :color="'primary'" v-bind="attrs"
                                                            v-on="on">mdi-help-circle</v-icon>
                                                    </template>
                                                    <span>Documentos que comprovem a origem do negócio</span>
                                                </v-tooltip>
                                            </v-col>
                                            <v-col cols="12" lg="12">
                                                <v-text-field :disabled="dataset.loading" readonly hide-details="auto"
                                                    prepend-icon="mdi-paperclip" :clearable="true"
                                                    aria-label="Anexar os documentos comprobatórios do negócio"
                                                    @click:clear="clearDocs(i, 3)" label="Documentos Comprobatórios"
                                                    @click.prevent="openDocumentModal(i, 3)" outlined class="mt-1" dense
                                                    @keydown.enter.prevent="openDocumentModal(i, 3)"
                                                    :value="getDocsByType(i, 3)" :rules="[$rules.required]" />
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <span class="mr-3"> <strong>Informe uma observação referente ao
                                                        negócio</strong></span>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon small :color="'primary'" v-bind="attrs"
                                                            v-on="on">mdi-help-circle</v-icon>
                                                    </template>
                                                    <span>Informações adicionais referente ao negócio</span>
                                                </v-tooltip>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-textarea :disabled="dataset.loading" dense id="description"
                                                    aria-label="Preencha este campo com informações adicionais referente ao negocio"
                                                    label="Informações Adicionais" :rules="[
                                                        $rules.maxlength(
                                                            item.observation,
                                                            500
                                                        )
                                                    ]" counter="500" v-model="item.observation" outlined
                                                    hide-details="auto" rows="2" auto-grow></v-textarea>
                                            </v-col>
                                        </v-row>



                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                            <br>
                            <br>
                        </v-col>
                    </v-row>
                    <!-- <v-row>
                        <v-col>
                            <v-divider></v-divider>
                        </v-col>
                    </v-row> -->
                </div>
            </template>

            <v-row>
                <v-col>
                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-btn v-on="on" color="primary" :loading="dataset.loadingSave"
                                aria-label="Botão para salvar as alterações" @click.native="save">Salvar</v-btn>
                        </template>
                        <span>Salvar alterações</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-btn class="ml-4" v-on="on" type="button" elevation="0" color="primary" outlined
                                aria-label="Botão para retornar sem salvar os dados do negocio"
                                to="/revisao-credito">Voltar</v-btn>
                        </template>
                        <span>Retornar para revisão de crédito</span>
                    </v-tooltip>
                </v-col>
            </v-row>

        </v-form>

        <div v-else-if="user && !selectedCreditorId" class="mt-4">
            <v-alert type="info">
                Por favor, selecione um credor para cadastrar uma nova revisão de crédito.
            </v-alert>
        </div>

        <div v-if="user && hasPlanAdherence" class="mt-4">
            <v-alert border="left" style="background-color: #FFD54F; color: #000;" dense elevation="2" class="pa-3">
                <template v-slot:prepend>
                    <v-icon color="#757575" class="ml-3 mr-3">mdi-information</v-icon>
                </template>
                O credor selecionado já aderiu ao plano de recuperação judicial, portanto não é possível abrir uma
                revisão de crédito.
            </v-alert>
        </div>

        <div v-if="user && !userCanOpenCreditorRevision" class="mt-4">
            <v-alert border="left" style="background-color: #FF6D00; color:#FFFF;" dense elevation="2" class="pa-3">
                <template v-slot:prepend>
                    <v-icon color="#FFFFFF" class="ml-3 mr-3">mdi-information</v-icon>
                </template>
                O credor selecionado foi criado após a data {{ $moment(dateLimitOpenCreditorRevision).utc().format('DD-MM-YYYY') }} estipulada, portanto não é possível abrir uma
                revisão de crédito.
            </v-alert>
        </div>

        <div v-if="user && hasObjectionEvent" class="mt-4">
            <v-alert border="left" style="background-color: #FF6D00; color:#FFFF;" dense elevation="2" class="pa-3">
                <template v-slot:prepend>
                    <v-icon color="#FFFFFF" class="ml-3 mr-3">mdi-information</v-icon>
                </template>
                O credor selecionado já possui uma revisão de crédito em aberto, portanto não é possivel abrir uma nova.
            </v-alert>
        </div>

        <!-- MODAIS -->

        <v-dialog v-model="showDocumentModal" max-width="800px">
            <v-card>
                <v-card-title>
                    <v-row justify="center">
                        <v-col lg="12">
                            <h1 class="custom-modal-title text-uppercase black--text font-weight-bold">
                                Escolha um
                                <span class="underline text-uppercase primary--text">documento</span>
                            </h1>
                        </v-col>
                    </v-row>
                </v-card-title>

                <v-card-text>
                    <v-btn class='mb-3' @click="openAddModalDocument(currentDocTypeId)" color="primary">
                        Novo documento
                    </v-btn>
                    <v-expansion-panels v-model="panel" multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header>Selecionar da Central de Documentos</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-list dense v-if="!loadingDocuments">
                                    <v-list-item v-for="(doc, index) in documentsCenter" :key="index">
                                        <v-list-item-action>
                                            <v-checkbox v-model="doc.isSelected" :disabled="currentDocType !== 3 && currentDocType !== 4 &&
                                                !doc.isSelected && isAnyDocumentSelected">
                                            </v-checkbox>
                                        </v-list-item-action>
                                        <v-list-item-content>{{ doc.name }}</v-list-item-content>
                                        <v-list-item-content>{{ getDocTypeName(doc.type) }}</v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-progress-circular v-else indeterminate></v-progress-circular>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-card-actions class='pa-0 mt-4'>
                        <v-btn color="primary" @click="confirmSelection">Confirmar</v-btn>
                        <v-btn @click="checkDocumentsBeforeClose" text>
                            Cancelar
                        </v-btn>
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showAddDocumentModal" max-width="600px">
            <v-card>
                <v-card-title>
                    <v-row justify="center">
                        <v-col lg="12">
                            <h1 class="custom-modal-title text-uppercase black--text font-weight-bold">
                                Adicionar um
                                <span class="underline text-uppercase primary--text">documento</span>
                            </h1>
                        </v-col>
                    </v-row>
                </v-card-title>

                <v-form ref="formNewDocument" v-model="valid">

                    <v-card-text class='mt-1'>
                        <v-text-field outlined dense readonly :value="getDocTypeName(currentDocTypeId)"
                            label="Tipo de documento"></v-text-field>

                        <v-text-field outlined dense required :rules="[$rules.required]" v-model="newDocument.name"
                            label="Nome do documento"></v-text-field>

                        <v-file-input outlined dense required prepend-icon="mdi-paperclip" :rules="[$rules.required]"
                            v-model='newDocument.file' label="Selecionar documento">
                        </v-file-input>
                    </v-card-text>
                    <v-col sm='3' class="d-flex">
                        <v-btn @click="saveNewDocument" class='ml-auto' color="primary" block
                            :disabled="dataset.loading">
                            Enviar
                            <v-progress-circular v-if="dataset.loading" indeterminate color="white" size="20"
                                class="ml-2"></v-progress-circular>
                        </v-btn>
                        <v-btn class='ml-3' @click="closeAddDocumentsModal()" text>
                            Cancelar
                        </v-btn>
                    </v-col>
                </v-form>
            </v-card>
        </v-dialog>

        <v-dialog max-width="800px" v-model="showConfirmationDialog">
            <v-card>
                <v-card-title>Confirmação</v-card-title>
                <v-card-text>Você possui documento(s) selecionado(s) que não foram salvos! Deseja sair sem salvar
                    suas alterações?</v-card-text>
                <v-card-actions>
                    <v-btn text @click="continueWithoutSaving">Não</v-btn>
                    <v-btn text @click="closeAlertModal">Sim</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import 'moment/locale/pt-br';
import { eventHub } from '@/main';
import currencyTypes from '@/common/data/currency-types.data';
import itemTypes from "@/common/data/item-types.data.js";
import creditorTypes from "@/common/data/creditor-types.data.js";
import creditorOriginTypes from "@/common/data/creditor-origin-types.data.js";
import statesList from "@/common/data/states-list.data";
import courtList from "@/common/data/court-types.data"
import axios from 'axios';

export default {

    data: () => ({
        user: null,
        valid: true,
        panel: [0],
        showConfirmationDialog: false,
        loadingDocuments: false,
        currentDocTypeName: '',
        linkedCreditors: [], 
        selectedCreditorId: null, 
        hasPlanAdherence: false,
        hasObjectionEvent: false,
        userCanOpenCreditorRevision: true,
        dateLimitOpenCreditorRevision: null,
        dataset: {
            currencyTypes: currencyTypes,
            contentUserAnonymous: '',
            contentUserLogged: '',
            clients: [],
            selectedEventItem: -1,
            textDateLabel: null,
            data: {
                items: [],
                actionProgress: false,
            },
            acceptValue: true,
            loading: false,
            loadingSave: false,
            itemTypes: itemTypes,
            creditorTypes: creditorTypes,
            creditorOriginTypes: creditorOriginTypes,
            statesList: statesList,
            courtList: courtList,
            userRequestedValue: 0,
            isAssociationCreditor: false,
            notAcceptedValue: false,
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            created: null
        },
        showDocumentModal: false,
        showAddDocumentModal: false,
        documentsCenter: [],
        newDocument: {},
        selectedPetitionDocument: null,
        selectedProcurationDocument: null,
        selectedSpreadsheet: null,
        selectSuportingDocument: [],
        selectOtherDocuments: [],
        currentDocTypeId: null,
        processes: [
            {
                number: '',
                local: '',
                court: '',
            }
        ],
    }),

    mounted: function () { },

    computed: {

        isAnyDocumentSelected() {
            if (this.currentDocType === 'idOtherDocuments') {
                return false;
            }
            return this.documentsCenter.some(doc => doc.isSelected);
        },
        //implementar procurador
        showMainForm() {
            return this.user && this.selectedCreditorId && !this.hasPlanAdherence && this.userCanOpenCreditorRevision && !this.hasObjectionEvent;
        },
    },

    watch: {
        dataset: {
            handler(newVal) {
                newVal.data.items.forEach((item, index) => {
                    this.$watch(() => item.origin, (newValue) => {
                        this.onOriginChange(item, index);
                    });
                });
            },
            deep: true
        }
    },

    created() {
        // this.checkAccess();
        this.loadData();
    },

    methods: {

        //novas funções

        async onCreditorChange(creditorId) {

            this.hasPlanAdherence = false;
            this.userCanOpenCreditorRevision = true;
            
            await this.verifyAccess(creditorId)

            if(this.hasPlanAdherence || !this.userCanOpenCreditorRevision || this.hasObjectionEvent){
                return
            }

            this.selectedCreditorId = creditorId;
            this.resetForm();
        },

        resetForm() {
            this.dataset.data.items = [{
                currency: 1,
                step: 1,
                files: []
            }];
            this.dataset.data.actionProgress = false;
            this.processes = [{ number: '', local: '', court: '' }];
            this.dataset.acceptValue = true;
            this.dataset.notAcceptedValue = false;

        },

        async verifyAccess(creditor) {
            this.dataset.loading = true;

            try {
                
                const [planResponse, creditorRevisionResponse] = await Promise.all([
                    axios.get('/api/lawyer/plan-adherence-status/', {
                        params: { creditor_id: creditor }
                    }),
                    axios.get('/api/lawyers/creditor-revision/', {
                        params: { creditor_id: creditor }
                    })
                ]);

                let planData = null;
                if (planResponse.data && planResponse.data.content && planResponse.data.content.data) {
                    planData = planResponse.data.content.data;
                }

                if (planData && Number(planData.status) === 1) {
                    this.hasPlanAdherence = true;
                } else {
                    this.hasPlanAdherence = false;
                }


                let creditorRevisionData = null;
                if (creditorRevisionResponse.data && creditorRevisionResponse.data.content && creditorRevisionResponse.data.content.data) {
                    creditorRevisionData = creditorRevisionResponse.data.content.data;

                    this.dateLimitOpenCreditorRevision = creditorRevisionData.date_limit_open_creditor_revison;
          
                    this.hasObjectionEvent = creditorRevisionData.already_have_objection_event === true;

                    this.userCanOpenCreditorRevision = creditorRevisionData.can_open_creditor_revision === true;
                }else{
                    this.userCanOpenCreditorRevision = true;
                    this.hasObjectionEvent = true;
                }



                console.log("User CAN OPEN REVISION: ", this.userCanOpenCreditorRevision, creditorRevisionData)
            } catch (error) {
                this.$dialog.notify.error('Erro ao buscar informações!', {
                    position: 'top-right',
                    timeout: 3000,
                });
                this.creditors = [];
            } finally {
                this.dataset.loading = false;
            }
        },

        async loadData() {
            this.dataset.loading = true;

            try {
                await this.loadText();

                if (this.$root.user) {
                    await this.loadAssociatedUsers();
                    await this.loadUserInfo();
                    await this.loadClients();
                }

                // if (!Array.isArray(this.dataset.data.actionProgress)) {
                //     this.$set(this.dataset.data, 'actionProgress', []);
                // }
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 })
            } finally {
                this.dataset.loading = false
            }
        },

        formatValue(value, currency) {
            if (value === null || value === undefined) {
                return 'N/A';
            }

            let options = {
                style: 'currency',
                currency: 'BRL'
            };

            switch (currency) {
                case 1:
                    options.currency = 'BRL';
                    break;
                case 2:
                    options.currency = 'USD';
                    break;
                case 3:
                    options.currency = 'EUR';
                    break;
                default:
                    options.currency = 'BRL';
            }

            return new Intl.NumberFormat('pt-BR', options).format(value);
        },

        formatCpf(value) {
            if (!value) return '';
            return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
        },

        formatCnpj(value) {
            if (!value) return '';
            return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
        },

        formatRegistration(value) {
            if (!value) return '';
            return value.length <= 11 ? this.formatCpf(value) : this.formatCnpj(value);
        },


        onOriginChange(item, index) {

            if (!item) {

                return;
            }

            const selectedOrigin = this.dataset.creditorOriginTypes.find(o => o.name === item.origin);

            if (selectedOrigin) {
                if ([1, 2, 3, 4, 5].includes(selectedOrigin.id)) {

                    this.$set(this.dataset.data.items, index, {
                        ...this.dataset.data.items[index],
                        type: 3,
                        textDateLabel: 1
                    });

                }
                else {
                    this.$set(this.dataset.data.items, index, {
                        ...this.dataset.data.items[index],
                        type: 1,
                        textDateLabel: 2
                    });

                }
            }
        },

        onClassChange(item, index) {

            if (!item) {

                return;
            }

            if (item.type === 1) {

                this.$set(this.dataset.data.items, index, {
                    ...this.dataset.data.items[index],
                    textDateLabel: 2
                });

            } else if (item.type === 2 || item.type === 3 || item.type === 4) {
                this.$set(this.dataset.data.items, index, {
                    ...this.dataset.data.items[index],
                    textDateLabel: 1
                });

            }
        },

        addProcess() {
            if (this.processes.length < 10) {
                this.processes.push({
                    number: '',
                    local: '',
                    court: '',
                });
            }
        },

        removeProcess(index) {
            if (this.processes.length > 1) {
                this.processes.splice(index, 1);
            }
        },

        updateActionProgress(index, value) {
            this.$set(this.dataset.data.actionProgress, index, value);
        },

        getDocTypeName(docTypeId) {
            let docType = this.dataset.itemTypes.find(type => type.id === docTypeId);
            return docType ? docType.name : 'Tipo Desconhecido';
        },

        checkDocumentsBeforeClose() {
            if (this.documentsCenter.some(doc => doc.isSelected)) {
                this.showConfirmationDialog = true;
            } else {
                this.closeModal();
            }
        },

        updateRefDate(value, index) {

            this.$set(this.dataset.data.items, index, {
                ...this.dataset.data.items[index],
                ref_date: value
            });
        },

        clearDocs(index, type) {

            const filteredDocs = this.dataset.data.items[index].files.filter((x) => x.type != type)

            //this.dataset.data.items[index].docs = this.dataset.data.items[index].docs.filter(doc => doc.type !== type);

            this.dataset.data.items[index].files = filteredDocs

            return true;
        },

        closeAddDocumentsModal() {

            this.newDocument.name = null;
            this.newDocument.file = null;

            this.showAddDocumentModal = false;
        },

        closeAlertModal() {
            this.showConfirmationDialog = false;
            this.closeModal();
        },
        continueWithoutSaving() {
            this.showConfirmationDialog = false;
        },
        truncateText(text, maxLength) {
            return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
        },

        getDocsByType(index, type) {

            const result = this.dataset.data.items[index].files.filter((x) => x.type == type).map((x) => x.name).join("; ");

            return result;
        },


        async loadAssociatedUsers() {
            this.dataset.loading = true;
            try {
                const response = await axios.get('/api/lawyers/associated-users');
                const data = response.data.content.data; // Acesse o array dentro de content.data

                this.linkedCreditors = data.filter((x) => x.status == 1).map((x) => { return { id: x.user.id, name: x.user.name, registration: this.formatRegistration(x.user.registration) } });
            } catch (error) {
                console.error('Erro ao buscar credores associados:', error);
                this.$dialog.notify.error(this.$codes(error) || 'Erro ao carregar os credores associados. Por favor, tente novamente.', { position: 'top-right', timeout: 5000 });
                this.linkedCreditors = [];
            } finally {
                this.dataset.loading = false;
            }
        },


        hasDocument(index, type, required) {
            if (!required) return true;

            const items = this.dataset.data.items[index].files.filter((x) => x.type == type);

            return items.length > 0;
        },


        onCancel(index, step) {
            if (step > 1) {
                this.dataset.data.items[index].step = step - 1;
            }

            switch (step) {
                case 2:
                    this.selectedPetitionDocument = null;
                    this.selectedProcurationDocument = null;
                    this.dataset.data.items.file1 = null;
                    this.dataset.data.items.file2 = null;


                    break;
                case 3:
                    this.selectedProcurationDocument = null;
                    this.selectedSpreadsheet = null;
                    this.dataset.data.items.file2 = null;
                    this.dataset.data.items.file3 = null;
                    break;
                case 4:
                    this.selectedSpreadsheet = null;
                    this.selectSuportingDocument = [];
                    this.dataset.data.items.file3 = null;
                    this.dataset.data.items.file4 = [];

                    break;
                case 5:
                    this.selectSuportingDocument = [];
                    this.selectOtherDocuments = [];
                    this.dataset.data.items.file4 = [];
                    this.dataset.data.items.file5 = [];

                    break;
            }

        },

        getItemNumber(i) {
            return i + 1;
        },

        onInput(index, step) {
            if (!this.dataset.data.items[index].step) this.dataset.data.items[index].step = 1;

            if (this.hasDocument(index, step)) {
                this.dataset.data.items[index].step = step + 1;
            } else {
                this.$dialog.notify.error('Selecione um documento antes de continuar', {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async loadText() {
            const result = await axios.get(`/api/dynamic-infos/keys`, {
                params: { keys: 'create-user-event-anonymous,create-user-event-logged' }
            });

            if (!result.data.content) return;

            let contentUserAnonymous = result.data.content.find(
                (x) => x.key === 'create-user-event-anonymous'
            );
            let contentUserLogged = result.data.content.find(
                (x) => x.key === 'create-user-event-logged'
            );

            this.dataset.contentUserAnonymous = contentUserAnonymous
                ? contentUserAnonymous.value
                : '';
            this.dataset.contentUserLogged = contentUserLogged ? contentUserLogged.value : '';
        },

        async loadClients() {
            const result = await axios.get(`/api/clients`, { params: { limit: 100000 } });

            if (!result.data.content.data) return;

            this.dataset.clients = result.data.content.data;
        },

        async loadUserInfo() {
            const result = await axios.get('/api/user-objection-events/lawyer-request');

            this.user = result.data.content;
        },

        async load() {
            const result = await axios.get('/api/user-objection-events/lawyer-request');

            this.data = result.data.content;
        },


        validateFormItems() {
            if (!this.dataset.data.items.length) return false;

            for (let item of this.dataset.data.items) {
                if (!item.origin || !item.amount || !item.currency) {
                    return false;
                }

                if (!item.type || (Array.isArray(item.file4) && item.file4.length === 0)) {
                    return false;
                }
            }
            return true;
        },

        validateFormProcess() {
            if (!this.processes.length) return false;

            for (let item of this.processes) {
                if (!item.number || !item.local) {
                    return false;
                }

            }

            return true;
        },


        async acceptAssociationValue() {
            if (this.$moduleBlocked('site.review.agree_amount')) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja concordar com o valor?',
                title: 'Concordar com o valor',
                actions: {
                    false: 'Cancelar',
                    true: 'Concordar'
                }
            });

            if (!proceedAction) return;

            try {
                const response = await axios.post('/api/users/association/accept-value');

                await this.$dialog.confirm({
                    text: 'Valor aceito com sucesso!',
                    title: 'Sucesso',
                    actions: {
                        true: 'OK'
                    }
                });

                this.$router.replace('/revisao-credito');
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            } finally {
                this.dataset.loading = false;
            }
        },


        async acceptValueButtonSave() {

            this.dataset.notAcceptedValue = true;
            this.dataset.isAssociationCreditor = false;
        },


        async save() {
            if (this.$moduleBlocked('site.review.create.lawyer')) return;

            // if (!this.dataset.isAssociationCreditor) {
            //     this.dataset.notAcceptedValue = true;
            // }

            // if (this.dataset.acceptValue === true && this.dataset.isAssociationCreditor) {
            //     this.acceptAssociationValue();
            //     return;
            // }

            // if (this.dataset.acceptValue === false && this.dataset.notAcceptedValue === false) {
            //     this.acceptValueButtonSave();
            //     return;
            // }


            if (this.dataset.data.actionProgress) {

                const result = this.validateFormProcess()

                if (!result) {
                    this.$dialog.notify.error('Preencha todos os campos de um processo antes de continuar', { position: 'top-right', timeout: 2000 });

                    return;
                }
            }

            if (!this.$refs.form.validate()) {

                this.$dialog.notify.error(
                    'Preencha as informações obrigatórias de um negócio antes de continuar',
                    {
                        position: 'top-right',
                        timeout: 2000
                    }
                );
                return;
            }

            if (!this.dataset.data.items.length) {
                this.$dialog.notify.error(
                    'Preencha as informações de um negócio antes de continuar',
                    {
                        position: 'top-right',
                        timeout: 2000
                    }
                );
                return;
            }

            if (!this.validateFormItems()) {
                this.$dialog.notify.error('Preencha todos os campos antes de continuar', {
                    position: 'top-right',
                    timeout: 2000
                });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja concluir o formulário?',
                title: 'Finalizar',
                actions: {
                    false: 'Cancelar',
                    true: 'Concluir'
                }
            });

            if (!proceedAction) return;

            this.dataset.loadingSave = true;

            const payload = this.buildPayload();
            // payload.creditor_id = this.selectedCreditorId; // Adicione o ID do credor ao payload

            try {
                const response = await axios.post('/api/user-objection-events/lawyer-request', payload);

                await this.$dialog.confirm({
                    //text: 'Informações enviadas com sucesso! Você receberá um e-mail assim que sua solicitação for analisada.',
                    text: 'Seu pedido de revisão de crédito foi enviado! Os Administradores Judiciais nomeados irão analisar a documentação e os dados incluídos. O resultado será registrado neste site e enviado também pelo e-mail credito@rj123milhas.com.br. Continue acompanhando este site para informações oficiais e atualizadas sobre a Recuperação Judicial do Grupo 123 Milhas.',
                    title: 'Sucesso',
                    actions: {
                        true: 'OK'
                    }
                });

                this.dataset.data = { items: [] };

                this.$router.replace('/revisao-credito');
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            } finally {
                this.dataset.loadingSave = false;
            }
        },


        buildPayload() {
            let payload = {
                client_id: 1, // ID CASO FIXO (123MILHAS)
                user_id: this.selectedCreditorId, // Use o ID do credor selecionado
                // process_number: this.dataset.data.process_number,
                // process_local: this.dataset.data.process_local,
                // process_court: this.dataset.data.process_court,
                processes: this.dataset.data.actionProgress ? this.processes : [],
                items: [],
            };

            for (let item of this.dataset.data.items) {
                let itemData = {
                    currency: item.currency,
                    origin: item.origin,
                    amount: item.amount,
                    observation: item.observation,
                    type: item.type,
                    request_number: item.request_number,
                    company_name: item.company_name,
                    ref_date: item.ref_date,
                    files: []
                };

                for (let file of item.files) {
                    itemData.files.push(file.id);
                }

                payload.items.push(itemData);
            }

            return payload;
        },

        addItem() {
            this.dataset.data.items.push({
                currency: 1,
                step: 1,
                files: []
            });
        },

        async removeItem(index) {

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja <b>remover</b> o negócio atual?',
                title: 'Remover negócio',
                actions: {
                    false: 'Cancelar',
                    true: 'Remover'
                }
            });

            if (!proceedAction) return;

            this.dataset.data.items.splice(index, 1);
        },


        // UP DOC

        confirmSelection() {

            const selectedDocs = this.documentsCenter.filter(doc => doc.isSelected);

            const files = this.dataset.data.items[this.dataset.selectedEventItem].files;

            this.dataset.data.items[this.dataset.selectedEventItem].files = files.concat(selectedDocs);

            this.closeModal();
        },

        closeModal() {
            this.showDocumentModal = false;
            this.newFile = null;
            this.documentsCenter.forEach(doc => doc.selected = false);
        },

        closeAddModalDocument() {
            this.showAddDocumentModal = false;
        },

        openAddModalDocument(docTypeId) {
            this.currentDocTypeId = docTypeId;
            this.currentDocTypeName = this.getDocTypeName(docTypeId);
            this.showAddDocumentModal = true;
        },

        openDocumentModal(index, type) {
            this.currentDocType = type;

            this.dataset.selectedEventItem = index;

            this.currentDocTypeId = type;

            this.dataset.selectedEventItem = index;

            this.loadingDocuments = true;

            this.getDocuments(type).finally(() => {
                this.loadingDocuments = false;
                this.showDocumentModal = true;
            });
        },


        async getDocuments(docTypeId) {
            this.loadingDocuments = true;
            try {
                const userId = this.selectedCreditorId;
                const response = await axios.get(`/api/lawyers/associated-users/doc-list?user_id=${userId}`, {
                    params: { start: 0, limit: 1000, search: { "type": docTypeId } }
                });

                if (response.data && response.data.content && Array.isArray(response.data.content.data)) {
                    this.documentsCenter = response.data.content.data.map(doc => {
                        const docType = this.dataset.itemTypes.find(type => type.id === doc.type);
                        return {
                            isSelected: false,
                            name: doc.name,
                            type: doc.type,
                            created_at: doc.created_at,
                            file_url: doc.file_url,
                            id: doc.id
                        };
                    }).sort((a, b) => {
                        return new Date(b.created_at) - new Date(a.created_at);
                    });
                } else {
                    this.documentsCenter = [];
                    console.warn("Resposta da API de documentos com estrutura inesperada:", response.data);
                }

            } catch (error) {
                console.error("Erro ao obter documentos!", error);
                this.documentsCenter = []; // Limpa a lista 
            } finally {
                this.loadingDocuments = false;
            }
        },

        async saveNewDocument() {
            if (!this.$refs.formNewDocument.validate()) return;

            this.dataset.loading = true;

            try {
                let formData = new FormData();

                formData.append('user_id', this.selectedCreditorId);
                formData.append('name', this.newDocument.name);
                formData.append('type', this.currentDocTypeId);
                formData.append('file', this.newDocument.file);

                const response = await axios.post('/api/lawyers/associated-users/doc-create', formData);

                if (response.data && response.data.content) {
                    // Para lidar com a resposta do sucesso do upload
                    this.$dialog.notify.success("Documento salvo com sucesso!", { position: 'top-right', timeout: 5000 });
                    await this.getDocuments(this.currentDocTypeId); // Recarrega a lista de documentos
                    this.closeAddModalDocument();
                    this.newDocument = {};
                } else {
                    this.$dialog.notify.error("Erro ao salvar o documento.", { position: 'top-right', timeout: 5000 });
                }

            } catch (error) {
                console.error("Erro ao salvar o documento!", error);
                this.$dialog.notify.error("Erro ao salvar o documento!", { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.loading = false;
            }
        },
    },


};
</script>

<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    font-family: 'Raleway';
    font-size: 14px;
    font-style: normal;
}

.custom-modal-title {
    font-size: 20px;

    @media (max-width: 600px) {
        font-size: 14px;
    }
}
</style>
